/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetSocialConnectionsConnectionsForStationQueryResponse, GetSocialConnectionsConnectionsForStationPathParams, GetSocialConnectionsConnectionsForStationQueryParams } from "../models/GetSocialConnectionsConnectionsForStation";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getSocialConnectionsConnectionsForStation } from "../axios/getSocialConnectionsConnectionsForStation";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getSocialConnectionsConnectionsForStationQueryKey = (station: GetSocialConnectionsConnectionsForStationPathParams["station"], params: GetSocialConnectionsConnectionsForStationQueryParams = {}) => ["web-app-bff-api", { url: '/social-connections/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type GetSocialConnectionsConnectionsForStationQueryKey = ReturnType<typeof getSocialConnectionsConnectionsForStationQueryKey>

export function getSocialConnectionsConnectionsForStationQueryOptions(station: GetSocialConnectionsConnectionsForStationPathParams["station"], params?: GetSocialConnectionsConnectionsForStationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getSocialConnectionsConnectionsForStationQueryKey(station, params)
        return queryOptions<GetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, GetSocialConnectionsConnectionsForStationQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return getSocialConnectionsConnectionsForStation(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get connection states for a station (optional `platform` query filters to one platform)
 * {@link /social-connections/:station}
 */
export function useGetSocialConnectionsConnectionsForStation<TData = GetSocialConnectionsConnectionsForStationQueryResponse, TQueryData = GetSocialConnectionsConnectionsForStationQueryResponse, TQueryKey extends QueryKey = GetSocialConnectionsConnectionsForStationQueryKey>(station: GetSocialConnectionsConnectionsForStationPathParams["station"], params?: GetSocialConnectionsConnectionsForStationQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getSocialConnectionsConnectionsForStationQueryKey(station, params)
         

         const query = useQuery({
          ...getSocialConnectionsConnectionsForStationQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}